// appEditDetail namespace — EditDetail.tsx (logged-in render-job detail page).
// Keys mirror pl/appEditDetail.ts exactly. Professional product English.
// Render currency UI = "gems".
export const appEditDetail = {
  loading: 'Loading…',
  error: { title: 'This edit could not be loaded.' },
  errorCode: 'edit-{status}',
  notFound: {
    title: 'Edit not found',
    body: 'This edit doesn’t exist or you don’t have access to it.',
    back: 'Back to Edits',
  },
  // R5 (rule 30): three state words. Queue and render are one "in queue".
  status: {
    ready: 'ready',
    failed: 'error',
    rendering: 'in queue',
  },
  crumb: {
    library: 'Edits',
    current: 'Edit',
    edit: 'edit {n}',
  },
  title: '{series} · edit {n}',
  copyId: 'Copy identifier',
  copied: 'Identifier copied.',
  actions: {
    download: 'Download MP4',
    reRender: 'Retry',
    delete: 'Delete',
    deleteFailed: 'Could not delete the edit.',
  },
  stage: {
    failed: 'The render did not finish',
  },
  deleteDialog: {
    title: 'Delete edit?',
    confirm: 'Delete edit',
    cancel: 'Cancel',
  },
  toast: {
    retried: 'Edit retried',
    ready: 'New edit ready.',
    failed: 'Render failed.',
    deleted: 'Edit deleted.',
  },
  retry: {
    confirmTitle: 'Retry edit?',
    confirmBody: 'The new render reshuffles the clips.',
    cost: 'Cost',
    have: 'You have',
    remain: 'Remaining',
    costFormula: '1 edit ×',
    cancel: 'Cancel',
    close: 'Close',
    dismiss: 'Close dialog',
    topUp: 'Top up tokens',
    // R5 (principle 8, artboard 08c): a title and a Cost / You have TABLE. The key
    // `noGemsBody` died — its third number was the first two subtracted.
    noGemsTitle: 'Not enough tokens',
    refreshingBalance: 'Refreshing balance…',
    balanceUnavailable: 'The current balance could not be confirmed.',
    busyTitle: 'Too many renders at once',
    busyBody: 'The render did not start; your balance is unchanged.',
    tryAgain: 'Try again',
    progressTitle: 'Render in progress',
    pollTitle: 'The render could not be checked',
    pollBody: 'The latest progress could not be loaded.',
    // `doneBody` ("New edit {n} is ready.") died: it repeated the title (session 31 R5).
    doneTitle: 'Edit ready',
    facts: 'Length and size',
    series: 'Series',
    failedTitle: 'Render failed',
    requestTitle: 'The render could not start',
    requestUnknown: 'We could not confirm whether the render started.',
    requestInvalid: 'These settings cannot start a render.',
    requestPackUnavailable: 'The clip pack is unavailable; choose another in Generator.',
    requestCode: 'retry-{code}',
  },
}
